import * as ko from 'knockout';
import entityBase from 'entityBase';

export class c_model_structure_consumables_view extends entityBase {
    part_category: KnockoutObservable<string>;

    constructor(item: any){
        super();
        if (typeof item === "string") {
            this.part_category = ko.observable(item);
        } else {
            this.part_category = ko.observable(item.part_category);
        }
    }
}